document.addEventListener("DOMContentLoaded", () => {
  const body = document.getElementById("size-chart-body");
  const tabs = document.querySelectorAll(".tab-btn");
  const pages = document.querySelectorAll(".tab-page");
  const container = document.querySelector(".tab-container");
  const trackEl = document.querySelector(".tab-track");


  let activePage = document.getElementById("charts");
  let unit = "cm";
  let isAnimating = false;


  if (trackEl) trackEl.style.position = "relative";
  pages.forEach((p) => {
    p.style.position = "absolute";
    p.style.inset = "0";
    p.style.width = "100%";
    p.style.boxSizing = "border-box";
    p.style.display = p === activePage ? "block" : "none";
  });
  if (activePage) activePage.classList.add("active");
  if (container) {
    container.style.transition = "height 0.6s cubic-bezier(0.4,0,0.2,1)";
  }
  function updateContainerHeight(el = activePage) {
    if (!container || !el) return;
    container.style.height = el.scrollHeight + "px";
  }
  updateContainerHeight();

  
  const measurementNotes = {
    manual: "All sizes are garment measurements taken flat; 1-3 cm difference may occur.",
    shoulder: "Distance between shoulder points.",
    length: "Vertical length from shoulder to hem.",
    bust: "Measured horizontally 1cm below the armhole.",
    waist: "Measured horizontally at the waistline.",
    hip: "Measured horizontally at the fullest part of the garment.",
    hem: "Width across the bottom hem.",
    sleeve: "From shoulder point to sleeve opening. Raglan: from back neck point to sleeve opening.",
    armhole: "Vertical distance from shoulder point to armhole point.",
    thigh: "Width of thigh measured flat.",
    cuff: "Width across the cuff.",
    pantlength: "From waist to hem along the side seam.",
    inseam: "From crotch to hem along inside leg.",
    outseam: "From waist to hem along outside leg.",
    rise: "From crotch seam to top of waistband.",
    backlength: "From back neck point to waistline.",
    legopening: "Width across the leg opening.",
    bwh: "Model's bust / waist / hip."
  };

  function generateMeasurementNote(headers, isModel = false) {
    const lowerHeaders = headers.map((h) =>
      h.toLowerCase().replace(/\s+/g, "")
    );
    const notes = [];

    if (!isModel && measurementNotes.manual) {
      notes.push(`<span style="color:#000;">Note:</span> ${measurementNotes.manual}`);
    }

    lowerHeaders.forEach((h, i) => {
      if (measurementNotes[h]) {
        const originalHeader = headers[i].trim();
        notes.push(`<span style="color:#000;">${originalHeader}:</span> ${measurementNotes[h]}`);
      }
    });

    if (isModel) {
      if (
        lowerHeaders.includes("bwh") ||
        lowerHeaders.includes("b/w/h") ||
        lowerHeaders.includes("bust") ||
        lowerHeaders.includes("waist") ||
        lowerHeaders.includes("hip") ||
        lowerHeaders.includes("bust/waist/hip") ||
        lowerHeaders.includes("bust/waist/hips")
      ) {
        notes.push(`<span style="color:#000;">BWH:</span> ${measurementNotes.bwh}`);
      }
    }

    return notes.length
      ? `<div class="size-note">${notes.join("<br>")}</div>`
      : "";
  }


  document.addEventListener("click", (e) => {
    const openBtn = e.target.closest("#open-size-chart");
    const closeBtn = e.target.closest("#close-size-chart, #close-size-chart-back");
    const overlay = e.target.closest("#size-chart-overlay");

    const drawer = document.getElementById("size-chart-drawer");
    const overlayEl = document.getElementById("size-chart-overlay");

    if (!drawer || !overlayEl || !body) return;

    if (openBtn) {
      drawer.classList.add("open");
      overlayEl.classList.add("open");
      renderSizeChart();
      requestAnimationFrame(() => updateContainerHeight());
    }

    if (closeBtn || overlay) {
      drawer.classList.remove("open");
      overlayEl.classList.remove("open");
    }
  });

  function renderSizeChart() {
    const raw = body.dataset.raw;
    if (!raw) return;

    const sections = raw
      .split(/\n\s*\n/)
      .map((s) => s.trim())
      .filter(Boolean);

    body.innerHTML = `
      <div style="margin-bottom: 16px;">
        <div style="display:flex; border:1px solid #ccc; width:200px;">
          <button id="btn-cm" class="active" style="flex:1; padding:6px; border:none; cursor:pointer; background:#000; color:#fff;">CM</button>
          <button id="btn-inch" style="flex:1; padding:6px; border:none; cursor:pointer; background:#fff; color:#000;">INCH</button>
        </div>
      </div>
    `;

    sections.forEach((section) => {
      const lines = section.split("\n").map((l) => l.trim()).filter(Boolean);
      const firstLine = (lines[0] || "").toLowerCase();

      if (firstLine.includes("try-on")) {
        body.insertAdjacentHTML("beforeend", renderModelTable(lines, true));
      } else if (firstLine.includes("recommendation")) {
        body.insertAdjacentHTML("beforeend", renderRecommendationTable(lines));
      } else if (
        firstLine.includes("model") ||
        firstLine.includes("height") ||
        firstLine.includes("weight")
      ) {
        body.insertAdjacentHTML("beforeend", renderModelTable(lines, false));
      } else {
        body.insertAdjacentHTML("beforeend", renderSizeTable(lines[0], lines));
      }
    });

    const btnCm = document.getElementById("btn-cm");
    const btnInch = document.getElementById("btn-inch");
    if (btnCm && btnInch) {
      btnCm.addEventListener("click", () => switchUnit("cm"));
      btnInch.addEventListener("click", () => switchUnit("in"));
    }

    updateContainerHeight();
  }


  function renderSizeTable(title, lines) {
    const headers = (lines[1] || "").split(",").map(h => h.trim());
    const rows = lines.slice(2).map((r) => {
      if (r.includes(":")) {
        const [size, values] = r.split(":");
        return [size.trim(), ...values.split(/[\/,]/).map(v => v.trim())];
      }
      return r.split(",").map(c => c.trim());
    });

    let html = `<div class="size-chart-block"><p style="text-transform:capitalize; font-size:18px;">${title}</p>`;
    html += `<table class="size-model-table" data-type="size"><thead><tr>${headers.map(h => `<th>${h}</th>`).join("")}</tr></thead><tbody>`;

    rows.forEach((row) => {
      html += `<tr>`;
      row.forEach((cell, idx) => {
        if (idx === 0) {
          html += `<td>${cell}</td>`; 
        } else {
          const num = parseFloat(cell);
          if (!isNaN(num)) {
            const inch = (num / 2.54).toFixed(1);
            html += `<td data-cm="${num}" data-inch="${inch}&quot">${unit === "cm" ? `${num} cm` : `${inch}&quot;`}</td>`;
          } else {
            html += `<td>${cell}</td>`;
          }
        }
      });
      html += `</tr>`;
    });

    html += `</tbody></table></div>`;
    return html;
  }


  function renderModelTable(lines, isTryOn = false) {
    const headerIdx = isTryOn ? 1 : (lines[0].includes(",") ? 0 : 1);
    const headers = (lines[headerIdx] || "").split(",").map(h => h.trim());
    const rows = lines.slice(headerIdx + 1).map(r => r.split(",").map(c => c.trim()));

    let html = `<div class="size-chart-block" style="margin-top:20px;">
      <p style="text-transform:capitalize; font-size:18px;">${isTryOn ? "Try-on Report" : "Model Info"}</p>
      <table class="size-model-table" data-type="model"><thead><tr>${headers.map(h => `<th>${h}</th>`).join("")}</tr></thead><tbody>`;

    rows.forEach((row) => {
      html += `<tr>`;
      row.forEach((cell, idx) => {
        const header = (headers[idx] || "").toLowerCase();

        if (header.includes("height/weight")) {
          const parts = cell.split("/").map(p => p.trim());
          if (parts.length === 2) {
            let cm = parseFloat(parts[0]);
            let kg = parseFloat(parts[1]);
            if (kg > 70) kg = kg / 2;
            const lbs = Math.round(kg * 2.20462);
            const totalIn = Math.round(cm / 2.54);
            const ft = Math.floor(totalIn / 12);
            const inch = totalIn % 12;
            const dispH = `${ft}'${inch}"`;
            html += `<td data-cm="${cm}" data-kg="${kg}" data-inch="${dispH}" data-lbs="${lbs}" data-merge="true">${unit === "cm" ? `${cm} cm / ${kg} kg` : `${dispH} / ${lbs} lbs`}</td>`;
            return;
          }
        }

        if (header.includes("height")) {
          const cm = parseFloat(cell);
          if (!isNaN(cm)) {
            const totalIn = Math.round(cm / 2.54);
            const ft = Math.floor(totalIn / 12);
            const inch = totalIn % 12;
            const dispH = `${ft}'${inch}"`;
            html += `<td data-cm="${cm}" data-inch="${dispH}">${unit === "cm" ? `${cm} cm` : dispH}</td>`;
            return;
          }
        }

        if (header.includes("weight")) {
          let kg = parseFloat(cell);
          if (kg > 70) kg = kg / 2;
          if (!isNaN(kg)) {
            const lbs = Math.round(kg * 2.20462);
            html += `<td data-kg="${kg}" data-lbs="${lbs}">${unit === "cm" ? `${kg} kg` : `${lbs} lbs`}</td>`;
            return;
          }
        }


if (
  header.includes("bwh") ||
  header.includes("b/w/h") ||
  header.includes("bust/waist/hip") ||
  header.includes("bust/waist/hips")
) {
  const parts = cell.split(/[\/ ]/).map(p => p.trim()).filter(Boolean);
  if (parts.length === 3) {
    const [bust, waist, hips] = parts.map(p => parseFloat(p));
    const bustIn = (bust / 2.54).toFixed(1);
    const waistIn = (waist / 2.54).toFixed(1);
    const hipsIn = (hips / 2.54).toFixed(1);

    html += `<td data-cm="${bust}/${waist}/${hips}" 
                  data-inch="${bustIn}&quot;/${waistIn}&quot;/${hipsIn}&quot;">
      ${unit === "cm" 
        ? `${bust}/${waist}/${hips} cm` 
        : `${bustIn}&quot;/${waistIn}&quot;/${hipsIn}&quot;`}
    </td>`;
    return;
  }
}


        
        html += `<td>${cell}</td>`;
      });
      html += `</tr>`;
    });

    html += `</tbody></table></div>`;
    return html;
  }

 

function renderRecommendationTable(lines) {
  const headers = (lines[1] || "").split(",").map(h => h.trim());
  const rows = lines.slice(2).map(r => r.split(",").map(c => c.trim()));

  let html = `<div class="size-chart-block" style="margin-top:20px;">
    <p style="text-transform:capitalize; font-size:18px;">Size Recommendation</p>
    <table class="size-model-table" data-type="recommendation">
      <thead><tr>`;


  headers.forEach((h, idx) => {
    if (idx === 0) {
      html += `<th>${unit === "cm" ? "Height (cm)" : "Height (ft'in\")"}</th>`;
    } else {
      const match = h.match(/([\d.]+)\s*[–\-]\s*([\d.]+)/);
      if (match) {
        let kg1 = parseFloat(match[1]), kg2 = parseFloat(match[2]);
        if (kg1 > 70) kg1 = kg1 / 2;
        if (kg2 > 70) kg2 = kg2 / 2;
        const lbs1 = Math.round(kg1 * 2.20462);
        const lbs2 = Math.round(kg2 * 2.20462);
        html += `<th data-kg="${kg1}–${kg2}" data-lbs="${lbs1}–${lbs2}">
          ${unit === "cm" ? `${kg1}–${kg2} kg` : `${lbs1}–${lbs2} lbs`}
        </th>`;
      } else {
        html += `<th>${h}</th>`;
      }
    }
  });
  html += `</tr></thead><tbody>`;

  
  rows.forEach((row) => {
    html += `<tr>`;
    row.forEach((cell, idx) => {
      if (idx === 0) {
        const match = cell.match(/(\d+)\s*[–\-]\s*(\d+)/);
        if (match) {
          const cm1 = parseFloat(match[1]), cm2 = parseFloat(match[2]);
          const in1 = Math.round(cm1 / 2.54), in2 = Math.round(cm2 / 2.54);
          const ft1 = Math.floor(in1 / 12), ft2 = Math.floor(in2 / 12);
          const inch1 = in1 % 12, inch2 = in2 % 12;
          const disp1 = `${ft1}'${inch1}&quot`, disp2 = `${ft2}'${inch2}&quot`;

          html += `<td data-range="height" 
                        data-cm-start="${cm1}" data-cm-end="${cm2}" 
                        data-inch-start="${disp1}" data-inch-end="${disp2}">
            ${unit === "cm" ? `${cm1}–${cm2} cm` : `${disp1}–${disp2}`}
          </td>`;
          return;
        }
      }
      html += `<td>${cell}</td>`;
    });
    html += `</tr>`;
  });

  html += `</tbody></table></div>`;
  return html;
}


 function switchUnit(newUnit) {
  unit = newUnit;
  const btnCm = document.getElementById("btn-cm");
  const btnInch = document.getElementById("btn-inch");
  if (btnCm && btnInch) {
    btnCm.style.background = unit === "cm" ? "#000" : "#fff";
    btnCm.style.color = unit === "cm" ? "#fff" : "#000";
    btnInch.style.background = unit === "in" ? "#000" : "#fff";
    btnInch.style.color = unit === "in" ? "#fff" : "#000";
  }


  document.querySelectorAll("#size-chart-body td").forEach((td) => {

    if (td.dataset.cm && td.dataset.inch && !td.dataset.kg && !td.dataset.range) {
      td.innerText = unit === "cm" ? `${td.dataset.cm} cm` : td.dataset.inch;
    }

    
    if (td.dataset.kg && td.dataset.lbs && !td.dataset.cm) {
      td.innerText = unit === "cm" ? `${td.dataset.kg} kg` : `${td.dataset.lbs} lbs`;
    }

  
    if (td.dataset.range === "height") {
      td.innerText = unit === "cm"
        ? `${td.dataset.cmStart}–${td.dataset.cmEnd} cm`
        : `${td.dataset.inchStart}–${td.dataset.inchEnd}`;
    }

   
    if (td.dataset.cm && td.dataset.kg && td.dataset.inch && td.dataset.lbs && td.dataset.merge === "true") {
      td.innerText = unit === "cm"
        ? `${td.dataset.cm} cm / ${td.dataset.kg} kg`
        : `${td.dataset.inch} / ${td.dataset.lbs} lbs`;
    }
  });

 
  document.querySelectorAll("#size-chart-body table").forEach((table) => {
    const type = table.dataset.type;
    table.querySelectorAll("thead th").forEach((th, idx) => {
      if (idx === 0) {
        if (type === "size") {
          th.innerText = "Size"; 
        }
        if (type === "recommendation") {
          th.innerText = unit === "cm" ? "Height (cm)" : "Height (ft'in\")";
        }
      }
      if (th.dataset.kg && th.dataset.lbs) {
        th.innerText = unit === "cm"
          ? `${th.dataset.kg} kg`
          : `${th.dataset.lbs} lbs`;
      }
    });
  });

  updateContainerHeight();
}

 
  tabs.forEach((btn) => {
    btn.addEventListener("click", () => {
      const targetId = btn.dataset.target;
      const targetPage = document.getElementById(targetId);
      if (!targetPage || targetPage === activePage || isAnimating) return;

      tabs.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
      isAnimating = true;

      const clean = (el) =>
        el.classList.remove(
          "slide-out-left",
          "slide-out-right",
          "slide-in-left",
          "slide-in-right"
        );
      clean(activePage);
      clean(targetPage);

      const goingLeft = targetId === "measuring";
      targetPage.style.display = "block";
      requestAnimationFrame(() => {
        updateContainerHeight(targetPage);
      });

      activePage.classList.remove("active");
      activePage.classList.add(
        goingLeft ? "slide-out-left" : "slide-out-right"
      );

      const onOutEnd = () => {
        activePage.removeEventListener("animationend", onOutEnd);
        activePage.style.display = "none";
        activePage.classList.remove("slide-out-left", "slide-out-right");

        targetPage.classList.add(goingLeft ? "slide-in-right" : "slide-in-left");

        const onInEnd = () => {
          targetPage.removeEventListener("animationend", onInEnd);
          targetPage.classList.remove("slide-in-left", "slide-in-right");
          targetPage.classList.add("active");
          activePage = targetPage;
          isAnimating = false;
          updateContainerHeight();
        };
        targetPage.addEventListener("animationend", onInEnd, { once: true });
      };
      activePage.addEventListener("animationend", onOutEnd, { once: true });
    });
  });

  window.addEventListener("resize", () => updateContainerHeight());



    
  let startX = 0;
  let currentX = 0;
  let isDragging = false;
  const threshold = 80; 
  const edgeWidth = 40; 
  const drawer = document.getElementById("size-chart-drawer");
  const overlayEl = document.getElementById("size-chart-overlay");

  if (drawer) {
    drawer.addEventListener("touchstart", (e) => {
      startX = e.touches[0].clientX;

      
      if (startX > edgeWidth) {
        isDragging = false;
        return;
      }

      isDragging = true;
      drawer.style.transition = "none"; 
    });

    drawer.addEventListener("touchmove", (e) => {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
      const diffX = currentX - startX;

     
      if (diffX > 0) {
        drawer.style.transform = `translateX(${diffX}px)`;
      }
    });

    drawer.addEventListener("touchend", () => {
      if (!isDragging) return;
      isDragging = false;

      const diffX = currentX - startX;
      drawer.style.transition = "transform 0.3s ease"; 

      if (diffX > threshold) {
        
        drawer.classList.remove("open");
        if (overlayEl) overlayEl.classList.remove("open");
        drawer.style.transform = "";
      } else {
        
        drawer.style.transform = "translateX(0)";
        setTimeout(() => {
          drawer.style.transition = "";
          drawer.style.transform = "";
        }, 300);
      }
    });
  }



    
  const wrapTables = () => {
    const tables = document.querySelectorAll(".size-chart-block table");
    tables.forEach(table => {
      if (!table.parentElement.classList.contains("size-chart-table-wrapper")) {
        const wrapper = document.createElement("div");
        wrapper.className = "size-chart-table-wrapper";
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      }
    });
  };

  
  wrapTables();

  
  const oldRender = renderSizeChart;
  renderSizeChart = function() {
    oldRender.apply(this, arguments);
    wrapTables();
  };




});


